import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { StyleProps } from 'src/model'

export const SideBarLabel = styled.span`
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: anywhere;
    font-size: 1.6rem;
    color: #ffffff;
    font-weight: 400
`
export const SideBarIcons = styled.div<StyleProps>`
    display: grid;
    place-items: center;
    width: auto;
    height: auto;
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
`